__turbopack_context__.v({
  "actions": "bio-module__U2V4aa__actions",
  "addExtra": "bio-module__U2V4aa__addExtra",
  "addExtras": "bio-module__U2V4aa__addExtras",
  "addLinkAction": "bio-module__U2V4aa__addLinkAction",
  "analyticsNotices": "bio-module__U2V4aa__analyticsNotices",
  "analyticsPanel": "bio-module__U2V4aa__analyticsPanel",
  "appearanceFields": "bio-module__U2V4aa__appearanceFields",
  "avatar": "bio-module__U2V4aa__avatar",
  "avatarDesign": "bio-module__U2V4aa__avatarDesign",
  "branding": "bio-module__U2V4aa__branding",
  "brandingCta": "bio-module__U2V4aa__brandingCta",
  "brandingDivider": "bio-module__U2V4aa__brandingDivider",
  "chart": "bio-module__U2V4aa__chart",
  "chartAxis": "bio-module__U2V4aa__chartAxis",
  "chartPlot": "bio-module__U2V4aa__chartPlot",
  "chartScale": "bio-module__U2V4aa__chartScale",
  "chartTitle": "bio-module__U2V4aa__chartTitle",
  "count": "bio-module__U2V4aa__count",
  "creatorName": "bio-module__U2V4aa__creatorName",
  "designControls": "bio-module__U2V4aa__designControls",
  "designHint": "bio-module__U2V4aa__designHint",
  "designPanel": "bio-module__U2V4aa__designPanel",
  "designSection": "bio-module__U2V4aa__designSection",
  "editModal": "bio-module__U2V4aa__editModal",
  "editorGrid": "bio-module__U2V4aa__editorGrid",
  "empty": "bio-module__U2V4aa__empty",
  "eyebrow": "bio-module__U2V4aa__eyebrow",
  "featureOption": "bio-module__U2V4aa__featureOption",
  "featuredLink": "bio-module__U2V4aa__featuredLink",
  "following": "bio-module__U2V4aa__following",
  "followingSetting": "bio-module__U2V4aa__followingSetting",
  "headerActions": "bio-module__U2V4aa__headerActions",
  "heroCover": "bio-module__U2V4aa__heroCover",
  "hint": "bio-module__U2V4aa__hint",
  "identity": "bio-module__U2V4aa__identity",
  "imageChoices": "bio-module__U2V4aa__imageChoices",
  "linkDescription": "bio-module__U2V4aa__linkDescription",
  "links": "bio-module__U2V4aa__links",
  "liveDot": "bio-module__U2V4aa__liveDot",
  "livePreview": "bio-module__U2V4aa__livePreview",
  "metricNotes": "bio-module__U2V4aa__metricNotes",
  "metricRow": "bio-module__U2V4aa__metricRow",
  "mobilePreview": "bio-module__U2V4aa__mobilePreview",
  "mobilePreviewCanvas": "bio-module__U2V4aa__mobilePreviewCanvas",
  "note": "bio-module__U2V4aa__note",
  "noteTitle": "bio-module__U2V4aa__noteTitle",
  "onboarding": "bio-module__U2V4aa__onboarding",
  "onboardingActions": "bio-module__U2V4aa__onboardingActions",
  "onboardingIntro": "bio-module__U2V4aa__onboardingIntro",
  "onboardingStep": "bio-module__U2V4aa__onboardingStep",
  "openLabel": "bio-module__U2V4aa__openLabel",
  "pageHeading": "bio-module__U2V4aa__pageHeading",
  "pageIdentity": "bio-module__U2V4aa__pageIdentity",
  "panel": "bio-module__U2V4aa__panel",
  "panelHeader": "bio-module__U2V4aa__panelHeader",
  "previewButton": "bio-module__U2V4aa__previewButton",
  "previewEmpty": "bio-module__U2V4aa__previewEmpty",
  "primaryAction": "bio-module__U2V4aa__primaryAction",
  "proBadge": "bio-module__U2V4aa__proBadge",
  "profileDetails": "bio-module__U2V4aa__profileDetails",
  "profileDisclosure": "bio-module__U2V4aa__profileDisclosure",
  "profileInput": "bio-module__U2V4aa__profileInput",
  "publicGlyph": "bio-module__U2V4aa__publicGlyph",
  "publicInner": "bio-module__U2V4aa__publicInner",
  "publicLink": "bio-module__U2V4aa__publicLink",
  "publicPage": "bio-module__U2V4aa__publicPage",
  "publication": "bio-module__U2V4aa__publication",
  "saveBar": "bio-module__U2V4aa__saveBar",
  "section": "bio-module__U2V4aa__section",
  "sectionFields": "bio-module__U2V4aa__sectionFields",
  "sectionGlyph": "bio-module__U2V4aa__sectionGlyph",
  "sectionHeading": "bio-module__U2V4aa__sectionHeading",
  "sectionTitle": "bio-module__U2V4aa__sectionTitle",
  "settingLabel": "bio-module__U2V4aa__settingLabel",
  "share": "bio-module__U2V4aa__share",
  "singleDay": "bio-module__U2V4aa__singleDay",
  "socials": "bio-module__U2V4aa__socials",
  "statRow": "bio-module__U2V4aa__statRow",
  "step": "bio-module__U2V4aa__step",
  "stepActive": "bio-module__U2V4aa__stepActive",
  "steps": "bio-module__U2V4aa__steps",
  "subtitle": "bio-module__U2V4aa__subtitle",
  "swatches": "bio-module__U2V4aa__swatches",
  "tabs": "bio-module__U2V4aa__tabs",
  "top": "bio-module__U2V4aa__top",
  "verified": "bio-module__U2V4aa__verified",
  "verifiedButton": "bio-module__U2V4aa__verifiedButton",
  "verifiedNote": "bio-module__U2V4aa__verifiedNote",
  "websiteLogo": "bio-module__U2V4aa__websiteLogo",
  "workspace": "bio-module__U2V4aa__workspace",
});
